module.exports = __webpack_public_path__ + "img/demo1.d5c1b4a0.png";